export enum DictCodeEnmu {
    //客户类型
    CUSTOMER_TYPE = "customer-type",
    //客户属性
    CUSTOMER_ATTR = "customer-attr",
    //供应商类型
    SUPPLIER_TYPE = "supplier-type",

    //配件类型
    MATERIAL_TYPE = "material-type",
    //配件类型 (发动机)
    MATERIAL_TYPE_ENGINE = "material-type.engine",
    //计量单位
    MATERIAL_UNIT = "unit",
    //品牌
    MATERIAL_BRAND = "material-brand",
    //发动机型号
    ENGINE_TYPE = "engine-type",

    //开户银行类型
    OPENBANK_TYPE = "account-bank",
    //账户类型
    ACCOUNT_TYPE = "account-type",
    //发票类型
    INVOICE_TYPE = "invoice-type",
    //发票状态
    INVOICE_STATUS = "invoice-status",
    //支付状态
    PAY_STATUS = "pay-status",
    //支付方式
    PAY_METHOD = "pay-method",
    //结算类型
    PAYEE_TYPE = "settle-type",
    //经济实体
    BENTITY = "bentity",
    //核销状态
    WRITE_OFF_STATUS = "write-off-status",

    // 文件类型
    DOCUMENT_TYPE = "document-type",
    //组织机构
    ORG = "cm-organization",
    //门店
    SHOP = "cm-shop",
    //门店类型
    SHOP_TYPE = "shop-type",
    //经济实体
    BE = "cm-business-entity",
    //入库员
    STAFF = "stock-io-staff",
    //送货员
    DELIVERYMAN = "deliveryman",
    //检验员
    INSPECTOR = "inspector",
    //直发员
    ZHIFA = "stock-io-staff.zhifa",

    //仓库类型
    WAREHOUSE_TYPE = "warehouse-type",
    //收款人
    PAYEE = "payee",

    //物流方式
    LOGISTIC_MODE = "logistic-_mode",
    //物流费结账方式
    LOGISTIC_PAY = "logistics-pay",

    //账户类型 （配件返利）
    ACC_TYPE_REBATE = "account-type.rebate",
    //账户类型 （油品返利）
    ACC_TYPE_REBATE_OIL = "account-type.rebate-oil",
    //贸易国别
    COUNTRY = "country",
    //贸易条款
    TRADE_CLAUSE = "trade-clause",
    //币种
    CURRENCY = "gtm.currency",
    //卸货港
    DISCHARTGE_PORT = "discharge-port",
    //装货港
    LOAD_PORT = "load-port",
    //运输方式
    TRANSPORT_MODE = "transport-mode",
    //货前后
    DEIIVERY = "b&a-delivery",
    //收汇方式
    COLLECT_METHOD = "collect-method",

    //贸易条款
    TRADE_CLF = "trade-clf",
    TRADE_CFR = "trade-cfr",
    TRADE_FOB = "trade-fob",

    //报价单 (总监已驳回)
    QUOTE = "quote",
    //报价单 (总监已驳回)
    QUOTE_DIR_REJECT = "quote.dir-reject",
    //报价单 (总监待审批)
    QUOTE_PEND_APPROVE = "quote.pend-approve",
    //报价单 (财务已驳回)
    QUOTE_FIN_REJECT = "quote.fin-reject",
    //报价单 (财务待审批)
    QUOTE_DIR_APPROVE = "quote.dir-approve",
    //报价单 (已开单)
    QUOTE_INIT = "quote.init",
    //报价单 (已作废)
    QUOTE_CANCEL = "quote.cancel",
    //报价单 (已报价)
    QUOTE_FINISH = "quote.finish",
    //报价单 (待报价)
    QUOTE_WAIT_FINISH = "gtm.quote.wait.finish",
    //报价单 (待结算)
    QUOTE_PEND_SETTLE = "quote.pend-settle",

    // 业务预警设置
    WARNING = 'warning',

    //外贸合同
    SALES = "sales",
    //外贸合同 (总监已驳回)
    SALES_DIR_REJECT = "sales.dir-reject",
    //外贸合同 (总监带审批)
    SALES_PEND_APPROVE = "sales.pend-approve",
    //外贸合同 (财务已驳回)
    SALES_FIN_REJECT = "sales.fin-reject",
    //外贸合同 (财务待审批)
    SALES_DIR_APPROVE = "sales.dir-approve",
    //外贸合同 (已开单)
    SALES_INIT = "sales.init",
    //外贸合同 (已报价)
    SALES_FINISH = "sales.finish",
    //外贸合同 (待收汇)
    SALES_PEND_SETTLE = "sales.pend-settle",
    //外贸合同 (已结算)
    SALES_SETTLE = "sales.settle",
    //外贸合同 (已结汇)
    SALES_SETTLEMENT = "sales.settlement",
    //外贸合同 (已发运)
    SALES_SHIP = "sales.ship",
    //外贸合同 (待发运)
    SALES_PEND_SHIP = "sales.pend-ship",
    //外贸合同 (已出库)
    SALES_EX_WAREHOUSE = "sales.ex-warehouse",


    //出运管理
    SHIPMENT = "shipment",
    //出运管理 已结算
    SHIPMENT_SETTLE = "shipment.settle",
    //出运管理 待结算
    SHIPMENT_PEND_SETTLE = "shipment.pend-settle",
    //出运管理 入库
    SHIPMENT_WAREHOUSE = "shipment.warehouse",
    //出运管理 清关
    SHIPMENT_CUS = "shipment.cus-clearance",
    //出运管理 交单
    SHIPMENT_PRESENT_BL = "shipment.present-bl",
    //出运管理 提单
    SHIPMENT_BL = "shipment.bl",
    //出运管理 装船
    SHIPMENT_LADE = "shipment.lade",
    //出运管理 报关放行
    SHIPMENT_DECLARE = "shipment.cus-declare",
    //出运管理 装柜
    SHIPMENT_CONTAINER = "shipment.container",
    //出运管理 订舱
    SHIPMENT_BOOK = "shipment.book",
    //出运管理 商检
    SHIPMENT_INSPECT = "shipment.inspect",
    //出运管理 已开单
    SHIPMENT_INIT = "shipment.init",


    //采购合同
    PURCHASE = "purchase",
    //采购合同 财务已驳回
    PURCHASE_FIN_REJECT = "purchase.fin-reject",
    //采购合同 财务待审批
    PURCHASE_DIR_APPROVE = "purchase.dir-approve",
    //采购合同 总监已驳回
    PURCHASE_DIR_REJECT = "purchase.dir-reject",
    //采购合同 已入库
    PURCHASE_WAREHOUSE = "purchase.warehouse",
    //采购合同 已结算
    PURCHASE_SETTLE = "purchase.settle",
    //采购合同 待结算
    PURCHASE_PEND_SETTLE = "purchase.pend-settle",
    //采购合同 已开单
    PURCHASE_INIF = "purchase.init",
    //采购合同 总监待审批
    PURCHASE_PEND_APPROVE = "purchase.pend-approve",

    //询价单
    INQUIRY = "inquiry",
    //询价单 作废
    INQUIRY_CANCEL = "inquiry.cancel",
    //询价单 待报价
    INQUIRY_PEND = "inquiry.pend",
    //已报价
    INQUIRY_PENDED = "gtm.inquiry.pend",
    //运输单据状态
    TRANSPORT_STATUS = "transport-status",
    //客户负责人
    CUSTOMER_MANAGER = "customer-manager",

    //信用证类型 
    // EXPORT_CREDIT_TYPE = "export-credit-type",
    EXPORT_CREDIT_TYPE = "lc-type",

    //退税状态 
    DRAWBACK = "drawback-status",

    //监管方式
    REGULATION_PATTERN = "gtm.regulation-pattern",
    //征免性质
    EXEMPTION_NATURE = "exemption-nature",

    //报关状态
    CLEARANCE_STATU = "clearance-status",
    //运送方式
    DELIVERY_METHOD = "delivery-method ",
    //日期方式
    DATE_TYPE = "date-type"
}